module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.tabbarIndex == 0 ? "考勤打卡" : "打卡记录") + "\n    "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n      " + _vm._s(_vm.userName) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "46px"
    }
  }, [(_vm.tabbarIndex == 0) ? _c('AttendanceCompoment') : _vm._e(), _vm._v(" "), (_vm.tabbarIndex == 1) ? _c('AttendanceCount') : _vm._e()], 1), _vm._v(" "), _c('tabbar', [_c('tabbar-item', {
    attrs: {
      "selected": _vm.tabbarIndex == 0
    },
    on: {
      "on-item-click": function($event) {
        _vm.tabbarIndex = 0
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("打卡")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "show-dot": "",
      "selected": _vm.tabbarIndex == 1
    },
    on: {
      "on-item-click": function($event) {
        _vm.tabbarIndex = 1
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("统计")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0de72052","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Attendance.vue
// module id = Cfac
// module chunks = 1